"use client"
import Box from "@mui/material/Box";
import {Grid, Typography} from "@mui/material";
import Container from "@mui/material/Container";
import Image from "next/image";
import React from "react";
import N1 from "/public/images/certificates/N1.png";
import N2 from "/public/images/certificates/N2.png";
import N3 from "/public/images/certificates/N3.png";
import FaIcon from "@/components/utilities/fa-icon";
import {useTheme} from "@mui/material/styles";
import AboutItem from "./about-item";
import Paper from "@mui/material/Paper";

interface AboutViewProps {
}

const AboutView: React.FC<AboutViewProps> = () => {
    const theme = useTheme()

    return (
        <Box className = "cog-background" >
            <Container
                maxWidth = 'lg'
                sx = {{
                    py: 6
                }}
            >
                <Box
                    display = "flex"
                    alignItems = "center"
                    flexDirection = "column"
                    mb = {3}
                >

                    <Typography fontSize = {20} mb = {2} textAlign = "left" fontWeight = {400} >
                        گروه پیکان پارس: باهم پیشرفت
                    </Typography >
                    <FaIcon fontSize = {24} color = {theme.palette.primary.main} faIcon = 'fa-arrow-down' />

                </Box >
                <Paper sx = {{p: 3}} >
                    <Grid container >
                        <Grid item xs = {12} >
                            <AboutItem
                                title = "درباره پیکان‌پارس"
                                description = {`    سامانه و وب‌سایت پیکان پارس، تحت مالکیت شرکت امین توس پارت، بزرگترین و جامع ترین بستر برای توزیع و فروش اینترنتی قطعات یدکی اصلی خودرو در ایران است.
پیکان پارس از سال 1392، فعالیت خود را به همت گروهی از فارغ‌التحصیلان حوزه فناوری اطلاعات و با بهره مندی از تجارب بزرگان صنف آغاز کرد و امروزه با بهره‌مندی از تیم‌های متخصص و فنی در زمینه‌های مختلف از جمله فروش، پشتیبانی، طراحی و برنامه‌نویسی، به توسعه و پیشرفت فعالیت‌های خود می‌پردازد.   

                                `}
                                faIcon = 'fa-rocket'
                            />
                        </Grid >

                        <Grid item xs = {12} >
                            <AboutItem
                                title = "رسالت يا بيانيه گروه پیکان پارس"
                                description = "موفقيت ما بر مبناي رضايت مستمر زنجيره ارزش آفريني (مصرف كنندگان نهايي، مشتريان، كاركنان، تامين كنندگان، سهامداران، تولیدکنندگان، واردکنندگان و...) در راستاي چشم‌انداز گروه پیکان‌پارس براي تبديل شدن به شرکتی با برندهای برتر در بازارهاي هدف مي باشد. ما به تغيير و نوآوري با ايجاد سازمان ياد گيرنده و سازمان تند آموز اهميت ويژه مي دهيم. ما به وجوه تمايزمان وفادار خواهيم ماند. ما اعتقاد داريم كيفيت مستمر در قطعات و خدمات جزء نيازهاي پايه مشتريانمان مي باشد. ما اهميت مشتريان برون و درون سازماني را درك كرده و در تمام برنامه ها و اقداماتمان رعايت خواهيم كرد."
                                faIcon = 'fa-hands-helping'
                                even
                            />
                        </Grid >

                        <Grid item xs = {12} >
                            <AboutItem
                                title = "اهداف استراتژيك گروه پیکان پارس"
                                description = {
                                    <ul >
                                        <li >طراحي و اجراي سيستم توزيع مويرگي آنلاین در سطح كشور</li >
                                        <li >طراحي و اجراي سيستم صادرات مناسب در سطح كشور هاي همسايه</li >
                                        <li >تكميل سبد كالايي برندهای گروه پیکان پارس در راستاي چشم انداز با همکاری
                                            سایر
                                            منابع توزیع کالا
                                        </li >
                                        <li >حفاظت از برندهای شرکت و همچنين وجوه تمايز در تمام حالات</li >
                                        <li >ارتقاء مستمر رضايت در زنجيره ارزش آفريني</li >
                                        <li >حصول به اهداف فروش و توسعه بازار به نحوي شايسته تر از رقبا</li >
                                    </ul >
                                }
                                faIcon = 'fa-rocket'
                            />
                        </Grid >

                        <Typography
                            width = '100%'
                            textAlign = 'center'
                            fontWeight = {500}
                            fontSize = {18}
                            mt = {3}
                            mb = {5}
                        >
                            گواهی‌نامه‌ ها
                        </Typography >

                        <Grid container spacing = {1} >
                            <Grid item xs = {12} sm = {4} textAlign = 'center' >
                                <Image src = {N1} alt = "N1" width = {300} height = {300} />
                            </Grid >

                            <Grid item xs = {12} sm = {4} textAlign = 'center' >
                                <Image src = {N2} alt = "N2" width = {300} height = {300} />
                            </Grid >

                            <Grid item xs = {12} sm = {4} textAlign = 'center' >
                                <Image src = {N3} alt = "N3" width = {300} height = {300} />
                            </Grid >

                        </Grid >
                    </Grid >
                </Paper >
            </Container >
        </Box >
    );
};

export default AboutView;
